export default {
  SET_PAGE_DETAILS: function (state, payloads) {
    state.details = payloads;
  },
};
